import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {getUniqueName, getParam} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';

declare var noUiSlider: any;
declare var wNumb: any;

@Component({
    selector: 'app-question-slider-parent',
    templateUrl: './question-slider-parent.component.html',
    styleUrls: ['./question-slider-parent.component.scss'],
    standalone: false
})
export class QuestionSliderParentComponent implements OnInit, OnChanges {

  @Input() showHeader = false;
  @Input() showCalculatedText = false;
  @Input() headerTitle: any;
  @Input() headerPrice = 0;
  @Input() isExcessSlider = false;
  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = getUniqueName('question-slider-panel');
  premium: any;
  sliderMin = 0;
  sliderMax = 10000;
  sliderInit = this.sliderMin;
  isPremiumLoading = false;
  tempQuestion: Question;
  skipped = false;
  showSkip = false;
  parameter: any;
  constructor(public questionService: GlobalQuestionService, private ref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      if (this.isExcessSlider) {
        this.showHeader = true;
        //if (this.question.answer === '') {
          this.isPremiumLoading = true;
          this.getPremium();
        //}
        return;
      }
      this.question = changes?.question?.currentValue;
      this.tempQuestion = JSON.parse(JSON.stringify(this.question));

      if (this.question) {
        this.sliderInit = +this.question.answer;
        if (this.question.excess === 1 && !this.isPremiumLoading && this.question?.answer) {
          this.isPremiumLoading = true;
          this.getPremium();
        } else {
          this.setSliderValues();
          this.questionAnswer.emit(this.question);
        }
      }
     
     
    }
    if (changes?.showHeader?.currentValue !== changes?.showHeader?.previousValue) {
      this.showHeader = changes?.showHeader?.previousValue;
    }
    if (changes?.showCalculatedText?.currentValue !== changes?.showCalculatedText?.previousValue) {
      this.showCalculatedText = changes?.showCalculatedText?.previousValue;
    }
    if (changes?.headerTitle?.currentValue !== changes?.headerTitle?.previousValue) {
      this.headerTitle = changes?.headerTitle?.previousValue;
    }
    if (changes?.headerPrice?.currentValue !== changes?.headerPrice?.previousValue) {
      this.headerPrice = changes?.headerPrice?.previousValue;
    }
    if (changes?.isExcessSlider?.currentValue !== changes?.isExcessSlider?.previousValue) {
      this.isExcessSlider = changes?.isExcessSlider?.previousValue;

      if (this.isExcessSlider) {
        this.showHeader = true;
      }
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.previousValue;
    }
    if (this.question.question_bubble && this.question.question_bubble !== '' && this.question.answer !== ''){
      this.showCalculatedText = true;
   }
  }

  saveSliderValue(sliderData: any): void {
    if (sliderData?.sliderValue > -1) {
      this.question.answer = sliderData.sliderValue.toString();
      if (this.tempQuestion?.answer !== this.question?.answer) {
        this.questionService.saveIndividualAnswer(this.question, this.question.item_id)
          .subscribe(r => {
            if (!this.isPremiumLoading) {
              this.isPremiumLoading = true;
              this.getPremium();
            }
          });
      }
    }
  }

  getPremium(): void {
    //this.questionService.spinner(true);
    this.questionService.spinnerTransparent(true);
    const productId = this.question?.product_id || 10;
    this.questionService.getPremium(this.question?.product_class_id, this.question?.item_id, productId)
      .subscribe((r: any[]) => {
        this.isPremiumLoading = false;
        //this.questionService.spinner(false);
        this.questionService.spinnerTransparent(false);
        if (r?.length) {
          this.premium = r[0];
        }
        this.setSliderValues();
        if (this.premium && this.premium?.premium) {
          //this.questionService.spinner(true);
          this.questionService.spinnerTransparent(true);
          this.questionService.updatePrices(productId, this.question?.product_class_id, this.question.item_id)
            .subscribe(() => {
              this.questionService.setShoppingCart(this.question, this.question?.item_id);
              //this.questionService.spinner(false);
              this.questionService.spinnerTransparent(false);
            }, error => {
              //this.questionService.spinner(false);
              this.questionService.spinnerTransparent(false);
            });
        }
      }, error => {
        //this.questionService.spinner(false);
        this.questionService.spinnerTransparent(false);
        this.isPremiumLoading = false;
      });
  }

  setSliderValues(): void {
    if (this.question?.excess === 1) {
      
       this.sliderMin = this.premium?.excess_mod_min > 0 ? this.premium?.excess_mod_min : 0;
       this.sliderMax = this.premium?.excess_mod_max ? this.premium?.excess_mod_max : 10000;
       if (this.question.answer === ''){
        this.premium.excess_mod = this.premium?.excess_min;
       }
       this.sliderInit = this.premium?.excess_mod > -1 ? this.premium?.excess_mod : this.premium?.excess_min ? this.premium.excess_min : +this.question.answer;
      // this.sliderInit = this.premium.excess_min;
      
    } else {
      this.sliderMin = this.question?.min_val ? this.question?.min_val : 0;
      this.sliderMax = this.question?.max_val ? this.question?.max_val : 10000;
      this.sliderInit = this.question?.answer ? +this.question?.answer : this.sliderMin;
    }
    if (this.sliderInit >= this.sliderMin && this.sliderInit <= this.sliderMax) {
      this.question.answer = this.sliderInit.toString();
    }
    // this.questionService.saveIndividualAnswer(this.question, this.question.item_id)
    // .subscribe(r => {
    // });
    
    this.questionAnswer.emit(this.question);
    //this.questionService.spinner(false);
    this.questionService.spinnerTransparent(false);
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
}
